import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map'; // add map function to observable
import 'rxjs/add/operator/catch';

import { environment } from '../../../environments/environment';
import { AuthenticationService, TokensService } from '../../services';

@Injectable()
export class UserService {

    private restURL = environment.apiURL + 'users/';
    private restURLTokens = environment.apiURL + 'tokens/';

    constructor(
        private http: Http,
        private authenticationService: AuthenticationService) {

    }

    getAvailableRoles() {
        return this.http.get(this.restURLTokens + 'roles', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })

            .catch((error: any) => {
                return Observable.throw(new Error("Roles not loadable"));
            });
    }

    removeRole(guid: string, role: string) {
        return this.http.delete(this.restURL + guid + '/roles/' + role, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not remove role from user"));
            });

    }

    apiUser(guid: string) {
        return this.http.put(this.restURL + guid + '/api', '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not patch user to apiUser"));
            });

    }

    unlock(guid: string) {
        return this.http.put(this.restURL + guid + '/unlock', '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not lock user"));
            });

    }

    lock(guid: string) {
        return this.http.put(this.restURL + guid + '/lock', '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not lock user"));
            });

    }

    deleteUser(guid: string) {
        return this.http.delete(this.restURL + guid, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not delete user"));
            });

    }

    addUser(name: string, pwd: string, api: boolean) {
        let user: any = {};
        user.logonName = name;
        user.password = pwd;
        user.apiUser = api;
        return this.http.post(this.restURL, user, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not create user"));
            });

    }

    addRole(guid: string, role: string) {
        return this.http.post(this.restURL + guid + '/roles/' + role, '', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not add role to user"));
            });

    }

    getRoles(guid: string) {
        return this.http.get(this.restURL + guid + '/roles', {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                let roles = res.json();
                return roles;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load user roles"));
            });
    }

    updateProfile(guid: string, profile: any) {        
        return this.http.put(this.restURL + guid + '/profile', profile, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res;
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not update user profile"));
            });
    }

    getUserProfile(guid: string) {        
                return this.http.get(this.restURL + guid + '/profile', {
                    headers: this.authenticationService.getHeader()
                })
                    .map((res: Response) => {
                        return res.json();
                    })
                    .catch((error: any) => {
                        return Observable.throw(new Error("Could not load user profile"));
                    });
            }
    
    getUser(guid: string) {
        return this.http.get(this.restURL + guid, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load user"));
            });
    }

    getUsers(locked: string, deleted: string) {
        let filter: string = "";
        if (locked != null) {
            filter = "?locked=" + locked;
        }
        if (deleted != null) {
            if (filter == "") {
                filter = "?deleted=" + deleted;
            } else {
                filter = filter + "&deleted=" + deleted;
            }
        }
        return this.http.get(this.restURL + filter, {
            headers: this.authenticationService.getHeader()
        })
            .map((res: Response) => {
                return res.json();
            })
            .catch((error: any) => {
                return Observable.throw(new Error("Could not load users"));
            });
    }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/_storageApp.Front.release/src/app/users/services/user.service.ts